
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutBOMGrid extends Serenity.EntityGrid<ApprovalOutBOMRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutBOM'; }
        protected getDialogType() { return ApprovalOutBOMDialog; }
        protected getIdProperty() { return ApprovalOutBOMRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutBOMRow.localTextPrefix; }
        protected getService() { return ApprovalOutBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}